import { useState, useEffect } from 'react'
import CardLocationLabel from './CardLocationLabel'
import CardItemCount from './CardItemCount'
import BidCountdown from '../BidCountdown/BidCountdown'
import BidEndDate from '../BidEndDate/BidEndDate'
import filterMaxCharacterCount from '../../utilities/filterMaxCharacterCount'
import C from 'utilities/constants'
import useLocalStorage from '../../utilities/hooks/useLocalStorage'
import Images from '@components/BidAuctionCard/Images'
import Link from 'next/link'
import getLocationString from '@utilities/functions/getLocationString'

export default function BidAuctionCard({ auction, inCarousel }: any) {
  const {
    id,
    title,
    location: { nickName, city, state },
    itemCount,
    utcEndDateTime,
    picUrl,
    pastAuction,
    auctionNumber,
    endTimeText,
  } = auction
  const [breakTitleWords, setbreakTitleWords] = useState<any>(false)
  const [auctionsVisited] = useLocalStorage('visitedAuctions', {})

  useEffect(() => {
    if (title && filterMaxCharacterCount(title, 14)) {
      setbreakTitleWords(true)
    }
  }, [title])

  return (
    <Link
      href={`/api/auction/${id}?utcEndDateTime=${utcEndDateTime}`}
      replace
      className={`text-left bid-auction-card flex flex-col h-full md:w-full
                overflow-hidden rounded-xl border border-bidfta-gray-border
                shadow-md hover:shadow-xl transition duration-300 ease-in-out ${
                  inCarousel ? 'max-w-xs' : ''
                } ${
        !!auctionsVisited[id] ? 'bg-bidfta-purple' : 'bg-white'
      } w-full`}
    >
      <Images
        picUrl={picUrl}
        title={title}
        inCarousel={inCarousel}
        isMemberOnly={auction?.auctionTypeId === C.MEMBERS_ONLY_TYPE_ID}
      />
      <div
        className={`h-full p-2.5 md:p-4 xl:px-8 xl:py-5 text-xs flex flex-col justify-between`}
      >
        <div>
          <h4
            className={`font-bold mb-1 ${
              inCarousel
                ? 'text-xl leading-6'
                : 'text-xs md:text-xl md:leading-6'
            } ${breakTitleWords ? 'break-all' : ''}`}
          >
            {title}
          </h4>
          <CardLocationLabel
            label={getLocationString(nickName, city, state)}
            twcss="mb-1"
            inCarousel={inCarousel}
          />
          <p className="block md:mb-1 " style={{ fontWeight: 'bold' }}>
            <span className="font-bold">Auction: {auctionNumber}</span>
          </p>
          <CardItemCount
            itemCount={itemCount}
            pastAuction={pastAuction}
            twcss={`${inCarousel ? 'mb-4' : 'mb-1 md:mb-4'}`}
            inCarousel={inCarousel}
            utcEndDateTime={utcEndDateTime}
          />
        </div>
        <div>
          <BidCountdown
            date={utcEndDateTime}
            inCarousel={inCarousel}
            pastAuction={pastAuction}
            itemClosed={itemCount <= 0}
          />
          <BidEndDate
            date={utcEndDateTime}
            endTimeText={endTimeText}
            inCarousel={inCarousel}
          />
        </div>
      </div>
    </Link>
  )
}
